$(document).ready(function(){
  $('.ctm_cart_drawer a').on('click', function(e){
    e.stopPropagation();
     return false;
}); 
  $('.search-modal').css('display','none');
 
 
  
  
  $(document).on('click','button.cstm_category_btn',function(){
    if($(window).width() < 750){
        
     $('.menu-drawer-container summary').trigger('click');
      }else{
    $('.megaMenuExist a.header__menu-item').trigger('click');
    }
})
// Hide show main seach layout START CODE
$(document).on('click','.modal__toggle-open', function(){
    $(".cstm_search").toggle();
   $('#Search-In-Modal').focus();
  var SearchInput = $('#Search-In-Modal');
      SearchInput.val(SearchInput.val());
      var strLength= SearchInput.val().length;
      SearchInput.focus();
      SearchInput[0].setSelectionRange(strLength, strLength);
    $('.desk_float_bar').toggleClass("open_search_box");
   $('.colHeaderSection').toggleClass("open_search_bar");
     $('.template-search__results .colHeaderSection').toggleClass('remove-margin');
  if ($(window).width() < 750) {
  $('.collection-sidebar-menu-mobile.sticky_togglemenu, .template-search .collection-sidebar-menu-mobile').toggle();
  }
});
  $(document).on('click','.modal__close-button', function(){
    $(".cstm_search").hide();
    $('.desk_float_bar').removeClass("open_search_box");
    $('.colHeaderSection').removeClass("open_search_bar");
       $('.template-search__results .colHeaderSection').removeClass('remove-margin');
      if ($(window).width() < 750) {
     $('.collection-sidebar-menu-mobile.sticky_togglemenu, .template-search .collection-sidebar-menu-mobile').show();
      }
});
  // Hide show main seach layout END CODE

// On hover product image popup START CODE

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).on('click','.product-grid-container .pdp_enlarge_icon', function(){
    var imageURL=  $(this).parents('.grid__item').find('.card__media img').attr('src');
    var pdpUrl = $(this).parents('.grid__item').find('a.pdp_item_url').attr('href');
    var this1 = this;
  if(imageURL != undefined){
    $('.product-image-popup-main a').attr('href',pdpUrl);
    $('.product-image-popup-main img').attr('src','');
    $('.product-image-popup-main img').attr('src',imageURL);
    $('.product-image-popup-main').fadeIn("slow");
   
  }
});


 $(document).on('mouseover','.product-grid-container .card__inner', function(){
    $(this).parents('.grid__item').find('.pdp_enlarge_icon').fadeIn("slow");
 });
   $(document).on('mouseleave','.product-grid-container .card__inner', function(){
    $(this).parents('.grid__item').find('.pdp_enlarge_icon').fadeOut("slow");
 });
  
// $(document).on('mouseover','.product-grid-container .card__inner', function(){
//      var imageURL= $('.card__media img',this).attr('src');
//     var pdpUrl = $(this).parents('.grid__item').find('a.pdp_item_url').attr('href');
//   // alert(pdpUrl);
//     var this1 = this;
//    setTimeout(function(){
//     var inview = $(this1).isInViewport();
//   if(inview == true && imageURL != undefined){
//     $('.product-image-popup-main a').attr('href',pdpUrl);
//     $('.product-image-popup-main img').attr('src','');
//     $('.product-image-popup-main img').attr('src',imageURL);
//   $('.product-image-popup-main').fadeIn("slow");
   
//   }
//        },1500);
// });
  
// $(".product-image-popup-main").mouseleave(function(){
//  $(this).fadeOut("slow");
// });

$(document).on('click','.close-icon', function(){
    $('.product-image-popup-main').fadeOut("slow");
})

   $(document).mouseup(function (e) { 
            if ($(e.target).closest(".product-image-popup-inner").length=== 0) { 
                $(".product-image-popup-main").fadeOut("slow"); 
            } 
        }); 
  // On Hover product image popup END CODE

$('.product-form__input input').click(function(){
    var data_val = $(this).attr('data-val');
$(this).parents('.product-form__input').find('input').attr('checked',false)
   $(this).attr('checked',true);
 
      $(this).parents('.product-form__input').find('input').removeClass('checked_active');
    $(this).addClass('checked_active');
  
   
})
// Mobile Toggle menu code START
 $.fn.inView = function(){
    //Window Object
    var win = $(window);
    //Object to Check
    obj = $(this);
    //the top Scroll Position in the page
    var scrollPosition = win.scrollTop();
    //the end of the visible area in the page, starting from the scroll position
    var visibleArea = win.scrollTop() + win.height();
    //the end of the object to check
    var objEndPos = (obj.offset().top + obj.outerHeight());
    return(visibleArea >= objEndPos && scrollPosition <= objEndPos ? true : false)
};

$(window).scroll(function(){
   var inview = $(".announcement-bar").inView();
  if(inview == true){
       $(".collection-sidebar-menu-mobile").addClass("sticky_togglemenu");
       $(".desk_float_bar.page-width").addClass("desk_togglebar");
    $(".mainHomeTemp .colHeaderSection, .colHeaderSection").addClass("hide_on_scrolled");
  }


  var scroll = $(window).scrollTop();
    if (scroll >= 10) {
        $("body").addClass("top_scrolled");
    } else {
       $("body").removeClass("top_scrolled");
       $(".collection-sidebar-menu-mobile").removeClass("sticky_togglemenu");
        $(".desk_float_bar.page-width").removeClass("desk_togglebar");
     $(".mainHomeTemp .colHeaderSection, .colHeaderSection").removeClass("hide_on_scrolled");
       
    }
  
});
  
// Toggle menu Code END


// if(window.location.href.indexOf('type=') <0){ 
  
// $('.collection-sidebar-menu a').each(function(index){
// var url = $(this).attr('href');
//   var this1 = $(this);
//   activeTab=false;
//   if($(this).hasClass('active-sidebar')){
//     activeTab=true;
//   }
//    $.ajax({
// url: url+'?view=collection-count&filter.p.product_type='+'T-Shirt',
// type: "GET",     
// dataType: "html",
// success: function(data) {

//   if(index == 1){
//     $('.count_main').text($(data).find('.collection-count').text());
//   }
//   this1.find('.count').text($(data).find('.collection-count').text());
//   $('.custom_main_menus li a[href="'+url+'"]').find('.count').text($(data).find('.collection-count').text());
//   console.log(activeTab);
//    if(activeTab == 'true'){
//      $('.mobile_coll_count').text($(data).find('.collection-count').text());
//    }
// },


// });
// }); 
//   setTimeout(function(){  $('.mobile_coll_count').text($('.collection-sidebar-menu a.active-sidebar .count').text())},500)


// }


//if(window.location.href.indexOf('search?') > -1){ 
  // $(".icon-search").trigger('click');
// var data_type = $('.typesBlock.search_page  .prodType.colPage.active').attr('data-handle');
// $('.product-grid').find('.grid__item').hide();
//   $('.product-grid').find('.grid__item[data-type="'+data_type+'"]').show();
//   var product_count=0;
//  product_count = $('.product-grid').find('.grid__item[data-type="'+data_type+'"]').length;
//    var searchTerm=$('.appendProducts').attr('data-searchtterm');
//   if(searchTerm.indexOf('gift') > -1){
//     var count=product_count;
//     $('.appendProducts li').each(function(){
//       var pTitle=$(this).attr('data-product-title');
//       if(pTitle.indexOf('gift') >-1){
//         count=count+1;
//         $(this).show();
//     }
//     });
//     if(count >0){
//        product_count = count;
//     }
    
//   }
//    if(product_count == 0){
//         $('.no_products_tab').show();
//     }
//     $('h1.collection-hero__title.search_hero_title span.count').text(product_count);
// $('.typesBlock.search_page .prodType.colPage').click(function(e){
//     e.preventDefault()
//     $(this).addClass('active');
//     $('.typesBlock.search_page .prodType.colPage').not($(this)).removeClass('active');
//  var data_type = $(this).attr('data-handle');
//     $('.product-grid').find('.grid__item').hide();
//     $('.product-grid').find('.grid__item[data-type="'+data_type+'"]').show();
//   var product_count =0;
//       product_count = $('.product-grid').find('.grid__item[data-type="'+data_type+'"]').length;
//   if(data_type =='T-Shirt'){
//   var searchTerm=$('.appendProducts').attr('data-searchtterm');
//   if(searchTerm.indexOf('gift') > -1){
//      var count=product_count;
//     $('.appendProducts li').each(function(){
//       var pTitle=$(this).attr('data-product-title');
//       if(pTitle.indexOf('gift-cards') >-1){
//         count=count+1;
//         $(this).show();
//     }
//     });
//     if(count >0){
//       product_count = count;
//     }
//   }
//   }
//     if(product_count == 0){
//         $('.no_products_tab').show();
//     }else{
//    $('.no_products_tab').hide();
//     }
//     $('h1.collection-hero__title.search_hero_title span.count').text(product_count);
// });
// $(".collection-sidebar-menu a").removeClass("active-sidebar");
// var current_active_tab = sessionStorage.getItem("active_tab");
//   $('.typesBlock.search_page a[data-handle="'+current_active_tab+'"]').trigger('click')
// }
});


$(document).on('click','.thumbnail-list .thumbnail-list__item .thumbnail ',function(){
var color_name=$(this).attr('data-variant');
 console.log(color_name);
    if(color_name !='' || color_name != undefined){
 $('.ColorVariants input.color_input').not($('.ColorVariants input.color_input[data-val="'+color_name+'"]')).attr('checked',false).removeClass('checked_active');
$('.ColorVariants input.color_input[data-val="'+color_name+'"]').attr('checked',true).addClass('checked_active');
 var selected_val = '';
var flag = 0;
$('.product-form__input input').each(function(index){
    if($(this).attr("checked") == 'checked'){
       flag = flag+1;
    if(flag <= 1){
         selected_val =$(this).attr('data-val');
      
   }else{
        selected_val =selected_val+'-'+$(this).attr('data-val');
   }
    }
});
        console.log(selected_val);
var selected_id = $('.get_v_id_selector select option[data-title="'+selected_val+'"]').attr('value');
$('.product__info-wrapper product-form.product-form input[name="id"]').val(selected_id);

        
    }
    
});
// $(document).on('click','.header__icon--menu',function(){
//     $('.humbler_icon').addClass('active_menu_data');
// });
   $(document).mouseup(function(e) 
    {
        console.log('text');
    var container = $(".menu-drawer__inner-container");
   
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
       $('.menu-opening summary.header__icon[aria-controls="menu-drawer"]').trigger('click');
      }
    
    }); 
  
setTimeout(function(){
  $('.search-modal').css('display','block');
  $('footer').show();
  $('header').show();
  $('.announcement-bar').show();
},300);

setTimeout(() => { 
  $('#recently_product_wrapp .recently-viewed').slick('refresh');
}, 1000);
  
var wishlistPage = window.location.pathname;
if(wishlistPage == '/apps/advanced-wishlist') {
    $('body').addClass('wish-jtpl-list');
} else {
    $('body').removeClass('wish-jtpl-list');
}

  
 if ($("body").hasClass("temp-index")) {
var colhndle = $(".col-hnhome-home").val();
$(".typesBlock a").each(function(){
 var curl = $(this).attr("href"); 
 var result = curl.replace("collechandles", colhndle);
$(this).attr("href",result); 
});
 }
  
  setTimeout(function(){
    $('#recently_product_wrapp .slider-button--prev').prop("disabled", false);
  },800);
  $(".mMenuSection a.link.active, .list-menu__item--active").parents("li.custom_main_menu").find("span.detailedMenu.menu-drawer__menu-item.list-menu__item.link.link--text.focus-inset").addClass("menu-drawer__menu-item--active");

  var annheight = $('#shopify-section-announcement-bar').outerHeight();
  $('#shopify-section-header').css({"top":annheight});
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
        $("body").addClass("scrolled");
    } else {
        $("body").removeClass("scrolled");
    }
  });
  
  $(document).on('click','.scrTotop',function(){
    $('html, body').animate({
      scrollTop: $('html, body').offset().top,
    });
  });
  
  $(document).on('click','.megaMenuExist a.header__menu-item',function(e){
    e.preventDefault();
    $(this).closest('.megaMenuExist').find('.megaMenu').slideDown();
  }); 
  
  $(document).on('click','span.closeMenu',function(){
    $(this).closest('.megaMenu').slideUp();
  });
  
  $(document).on('click','.has-submenu .menu-drawer__menu-item',function(){
      $('.has-submenu .menu-drawer__menu-item').next().slideUp(200);
      if ( $(this).next().is(':hidden') ) {
        $(this).next().slideDown(200);
      } else {
        $(this).next().slideUp(200);
      }
  });



$('li.custom_main_menu.megaMenuExist_mobile').trigger('click');
$('li.custom_main_menu.megaMenuExist_mobile').find('.megaMenu.color-accent-1').slideDown(200);

// Recently viewed product limit in desktop and mobile start 
var liLength = $('#recentProds li').length;
if ($(window).width() < 990) {
if(liLength < 3){
    $('#recentProds .slider-button').addClass('hideButtonsMob');
} else {
    $('#recentProds .slider-button').removeClass('hideButtonsMob');
}
}
if ($(window).width() >= 990) {
if(liLength < 5){
    $('#recentProds .slider-button').addClass('hideButtonsDes');
} else {
    $('#recentProds .slider-button').removeClass('hideButtonsDes');
}
}

var interval = setInterval(doStuff, 500); // 2000 ms = start after 2sec 
function doStuff() {
 var countlen = $("product-recommendations ul li").length;
  if(countlen > 4){ 
      $('.recslider').slick({ 
         infinite : false,
        slidesToShow: 4,
        slidesToScroll: 4,   
        dots:true,
         
          
        prevArrow: '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-"><svg class="icon icon-next" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 18v-12l10 6-10 6z"/></svg></button>',
        nextArrow: '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-"><svg class="icon icon-next" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 18v-12l10 6-10 6z"/></svg></button>', 
        responsive: [
          {
            breakpoint: 999,
            settings: {
              rows: 2,  
              dots:true,
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          }
        ]
});
  clearInterval(interval);
  
  }
}  
  

// Recently viewed product limit in desktop and mobile End 


// // Media Alt Start
if ($(window).width() >= 990) {
// Click 
$('.mainProdTemplate .product__info-container .ColorVariants label').click(function(){
  var variantColor =  $(this).prev('input').attr('value');
   var variantCount = 0;
   var num = 0;
   $('.mainProdTemplate .thumbnail-slider ul li').each(function(){
   let imgAlt = $(this).find('img').attr('alt');
   var altArray = imgAlt.split('|');
   var alt = altArray[altArray.length-1];
   if(alt == variantColor) {
       $(this).show();
       if(num == 0) {
       $(this).addClass('thumbnail-slider-border-image');
       }
       num++;
       variantCount++;
   } else {
       $(this).hide();
       $(this).removeClass('thumbnail-slider-border-image');
   }
  });
    if(variantCount == 0) {
    $('.mainProdTemplate .thumbnail-slider ul li').show();
    $('.mainProdTemplate .thumbnail-slider ul li:first-child button').trigger('click');
    var clickCount = $('.mainProdTemplate .thumbnail-slider ul li').length;
   setTimeout(function(){
    $('.slider-counter--total').text(clickCount);
  },1000)
  } else {
    setTimeout(function(){
    $('.slider-counter--total').text(variantCount);
  },1000)
  }

setTimeout(()=>{
  var imgCount = 0;
  $('.thumbnail-slider .thumbnail-list__item').each(function(){
        var className = $(this).hasClass('thumbnail-slider-border-image');
        // console.log(className);
        if(className == true){
        var belowImgAlt =  $(this).find('img').attr('alt'); 
         $('.custom-slider-class .product__media img').each(function(){
          var upperImgAlt = $(this).attr('alt');
          if(belowImgAlt == upperImgAlt){
            if (imgCount == 0) {
              $(this).parent().parent().parent().addClass('is-active');
            }
            imgCount++;
          } else {
              $(this).parent().parent().parent().removeClass('is-active');
          }
      })
    }  
    });
},500)

if(num < 5 && num > 0){
    $('.productMain_section .thumbnail-slider .slider-button').addClass('hideButtonsDes');
} else {
    $('.productMain_section .thumbnail-slider .slider-button').removeClass('hideButtonsDes');
}

if(num == 0) {
    var lilen = $('.productMain_section .thumbnail-slider ul li').length;
    if (lilen == 0){
      $('.productMain_section .thumbnail-slider .slider-button').addClass('hideButtonsDes');
    } else {
       $('.productMain_section .thumbnail-slider .slider-button').removeClass('hideButtonsDes');
    }
}

  
});

// Load

var varCount = 0;
var num = 0;
$('.product__info-container .ColorVariants input').each(function(){
    let checkVal = $(this).attr('checked');
    if (checkVal == 'checked') {
       var variantColor = $(this).attr('value');   
       $('.mainProdTemplate .thumbnail-slider ul li').each(function(){
       let imgAlt = $(this).find('img').attr('alt');
       var altArray = imgAlt.split('|');
       var alt = altArray[altArray.length-1];
       if(alt == variantColor ) {
         $(this).show();
         if(num == 0) {
         $(this).addClass('thumbnail-slider-border-image');
         }
         varCount++;
         num++;
       } else {
        $(this).hide();
        $(this).removeClass('thumbnail-slider-border-image');
      }
    });
    if(varCount == 0) {
    $('.mainProdTemplate .thumbnail-slider ul li').show();
    var loadCount = $('.mainProdTemplate .thumbnail-slider ul li').length;
   setTimeout(function(){
    $('.slider-counter--total').text(loadCount);
  },1000)
  } else {
    setTimeout(function(){
    $('.slider-counter--total').text(varCount);
  },1000)
  }

setTimeout(()=>{
  var imgCount = 0;
  $('.thumbnail-slider .thumbnail-list__item').each(function(){
        var className = $(this).hasClass('thumbnail-slider-border-image');
        // console.log(className);
        if(className == true){
        var belowImgAlt =  $(this).find('img').attr('alt'); 
         $('.custom-slider-class .product__media img').each(function(){
          var upperImgAlt = $(this).attr('alt');
          // console.log(belowImgAlt,upperImgAlt);
          if(belowImgAlt == upperImgAlt){
            if (imgCount == 0) {
              $(this).parent().parent().parent().addClass('is-active');
            }
            imgCount++;
          } else {
              $(this).parent().parent().parent().removeClass('is-active');
          }
      })
    }  
    });
},500)

  
} 
});
if(num < 5){
    $('.productMain_section .thumbnail-slider .slider-button').addClass('hideButtonsDes');
} else {
    $('.productMain_section .thumbnail-slider .slider-button').removeClass('hideButtonsDes');
}

if(num == 0) {
    var lilen = $('.productMain_section .thumbnail-slider ul li').length;
    if (lilen == 0){
      $('.productMain_section .thumbnail-slider .slider-button').addClass('hideButtonsDes');
    } else {
       $('.productMain_section .thumbnail-slider .slider-button').removeClass('hideButtonsDes');
    }
}

}

if ($(window).width() < 990) {
// Click
$('.mainProdTemplate .product__info-container .ColorVariants label').click(function(){
  var variantColor =  $(this).prev('input').attr('value');
   var variantCount = 0;
   var num = 0;
   $('.mainProdTemplate .thumbnail-slider.slider-mobile-gutter ul li').each(function(){
   let imgAlt = $(this).find('img').attr('alt');
   var altArray = imgAlt.split('|');
   var alt = altArray[altArray.length-1];
   if(alt == variantColor) {
       $(this).show();
       if(num == 0) {
         $(this).addClass('thumbnail-slider-border-image');
       }
       variantCount++;
       num++;
   } else {
       $(this).hide();
       $(this).removeClass('thumbnail-slider-border-image');
   }
  });


          
  $('.custom-slider-class ul li').each(function(){
   let mobileImgAlt = $(this).find('.product__media img').attr('alt');
   var altArray = mobileImgAlt.split('|');
   var alt = altArray[altArray.length-1];
   if(alt == variantColor) {
       $(this).show();
   } else {
       $(this).hide();
   }
  });
    
    if(variantCount == 0) {
    $('.mainProdTemplate .thumbnail-slider.slider-mobile-gutter ul li').show();
    $('.mainProdTemplate .thumbnail-slider ul li:first-child button').trigger('click');
    $('.custom-slider-class ul li').show();
    var clickCount = $('.mainProdTemplate .thumbnail-slider ul li').length;
   setTimeout(function(){
    $('.slider-counter--total').text(clickCount);
  },1000)
  } else {
    setTimeout(function(){
    $('.slider-counter--total').text(variantCount);
  },1000)
  }
  
  });


// Load

var varCount = 0;
var num = 0;
$('.product__info-container .ColorVariants input').each(function(){
    let checkVal = $(this).attr('checked');
    if (checkVal == 'checked') {
       var variantColor = $(this).attr('value');   
       $('.mainProdTemplate .thumbnail-slider ul li').each(function(){
       let imgAlt = $(this).find('img').attr('alt');
       var altArray = imgAlt.split('|');
       var alt = altArray[altArray.length-1];
       if(alt == variantColor ) {
         $(this).show();
         if(num == 0) {
         $(this).addClass('thumbnail-slider-border-image');
         }
         varCount++;
         num++;
       } else {
        $(this).hide();
        $(this).removeClass('thumbnail-slider-border-image');
      }
    });

    $('.custom-slider-class ul li').each(function(){
   let mobileImgAlt = $(this).find('.product__media img').attr('alt');
   var altArray = mobileImgAlt.split('|');
   var alt = altArray[altArray.length-1];
   if(alt == variantColor) {
       $(this).show();
   } else {
       $(this).hide();
   }
  });

        
     if(varCount == 0) {
    $('.mainProdTemplate .thumbnail-slider ul li').show();
     $('.custom-slider-class ul li').show();
    var loadCount = $('.mainProdTemplate .thumbnail-slider ul li').length;
   setTimeout(function(){
    $('.slider-counter--total').text(loadCount);
  },1000)
  } else {
    setTimeout(function(){
    $('.slider-counter--total').text(varCount);
  },1000)
  }
} 
});

}

// Thumbnail image border
$('.thumbnail-list__item').click(function(){
    var classs = $(this).hasClass('thumbnail-slider-border-image');
    if(classs == false){
       $('.thumbnail-list__item').removeClass('thumbnail-slider-border-image'); 
    }
});

if ($(window).width() < 990) {
$('.icon-next').click(function(){
    $('.thumbnail-slider .thumbnail-list__item').removeClass('thumbnail-slider-border-image');
})
}
// // Media Alt End
function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var coll_type = getParameterByName('type'); 
$(".typesBlock img[data='"+coll_type+"']").parent().addClass("active");


 if ($("body").hasClass("temp-index")) {
   $(".typesBlock").each(function(){
      $(this).find("a:first-child").addClass("active");
 });

 }

// Slider arrow text on hover start
$('.slider-button--next').mouseover(function(){
    $('.slider-button--next span').css('display','block');
});
$('.slider-button--next').mouseout(function(){
    $('.slider-button--next span').css('display','none');
});

$('.slider-button--prev').mouseover(function(){
    $('.slider-button--prev span').css('display','block');
});
$('.slider-button--prev').mouseout(function(){
    $('.slider-button--prev span').css('display','none');
});
// Slider arrow text on hover end

// $('.custom_main_menu').click(function(){ 
//  $(this).prevAll('.custom_main_menu').removeClass('open');
//  $(this).nextAll('.custom_main_menu').removeClass('open');
//  $(this).toggleClass('open');
// });


// Predictive Search for Product Tag Start (1)
// $(document).ready(function(){
// $('.search__input').on('keyup keyup',function(e){
// var q = e.target.value;
//       var b = '&resources[options][fields]=tag'
//       $.ajax('/search/suggest.json?q=' + q + b,{
//         type: 'GET',
//         dataType: 'json', // added data type
//         success: function(response) {
//             $('.predictive-search-product-tag').remove();
//              $('.product-tag-search-heading').remove();
//           	var productSuggestions = response.resources.results.products;
//           	if (productSuggestions.length > 0) {
//             	$(`<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing product-tag-search-heading">
//                      Tags
//                     <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//                       <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//                     </svg>
//                    </h2>
//                   <ul id="predictive-search-results-list" class="predictive-search__results-list list-unstyled predictive-search-product-tag" role="listbox" aria-labelledby="predictive-search-products">
//                     <li id="predictive-search-option-search-keywords" class="predictive-search__list-item" role="option">
//                     </li> 
//                   </ul>`).insertBefore('.predictive-search__item.predictive-search__item--term')
//           	}
//             var array = productSuggestions;
//             $.each(array, function(key,value) {
//               $('.predictive-search-product-tag').append(`
//                 <li id="predictive-search-option-1" class="predictive-search__list-item" role="option" aria-selected="false">
//                   <a href="${value.url}" class="predictive-search__item predictive-search__item--link link link--text" tabindex="-1"><img class="predictive-search__image" src="${value.featured_image.url}" alt="${value.featured_image.alt}" width="50" height="50.0"><div class="predictive-search__item-content predictive-search__item-content--centered"><h3 class="predictive-search__item-heading h5">${value.title}</h3></div>
//                   </a>
//                 </li>`)  
//         });
//       }
//    });
// });
// });
// Predictive Search for Product Tag End (1)

// Predictive Search for Product Tag Start (2)
// $(document).ready(function(){
// $('.search__input').on('keyup keyup',function(e){
// var q = e.target.value;
//       var b = '&resources[options][fields]=tag'
//       $.ajax('/search/suggest.json?q=' + q + b,{
//         type: 'GET',
//         dataType: 'json', // added data type
//         success: function(response) {
//             $('.predictive-search-product-tag').remove();
//              $('.product-tag-search-heading').remove();
//           	var productSuggestions = response.resources.results.products;
//           	if (productSuggestions.length > 0) {
//             	$(`<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing product-tag-search-heading">
//                      Tags
//                     <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//                       <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//                     </svg>
//                    </h2>
//                   <ul id="predictive-search-results-list" class="predictive-search__results-list list-unstyled predictive-search-product-tag" role="listbox" aria-labelledby="predictive-search-products">
//                     <li id="predictive-search-option-search-keywords" class="predictive-search__list-item" role="option">
//                     </li> 
//                   </ul>`).insertBefore('.colection_search_head')
//           	}
//             var array = productSuggestions;
//             $.each(array, function(key,value) {
//               $('.predictive-search-product-tag').append(`
//                 <li id="predictive-search-option-1" class="predictive-search__list-item" role="option" aria-selected="false">
//                   <a href="${value.url}" class="predictive-search__item predictive-search__item--link link link--text" tabindex="-1"><div class="predictive-search__item-content predictive-search__item-content--centered"><h3 class="predictive-search__item-heading h5">${value.title}</h3></div>
//                   </a>
//                 </li>`)  
//         });
//       }
//    });
// });
// });
// Predictive Search for Product Tag End (2)

// Predictive Search for Product Tag Start (3)
// $(document).ready(function(){
// $('.search__input').on('keyup keyup',function(e){
// var q = e.target.value;
// var path = window.location.pathname;
//    if(path == '/search') {
//      var b = '&resources[options][fields]=tag'
//    } else {
//      var b = '&resources[options][fields]=tag&resources[limit]=5'
//    }
//       $.ajax('/search/suggest.json?q=' + q + b,{
//         type: 'GET',
//         dataType: 'json', // added data type
//         success: function(response) {
//             $('.predictive-search-product-tag').remove();
//              $('.product-tag-search-heading').remove();
//           	var productSuggestions = response.resources.results.products;
//           	if (productSuggestions.length > 0) {
//             	$(`<h2 style="display:none" id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing product-tag-search-heading">
//                      Tags
//                     <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//                       <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//                     </svg>
//                    </h2>
//                   <ul id="predictive-search-results-list" class="predictive-search__results-list list-unstyled predictive-search-product-tag" role="listbox" aria-labelledby="predictive-search-products">
//                     <li id="predictive-search-option-search-keywords" class="predictive-search__list-item" role="option">
//                     </li> 
//                   </ul>`).insertBefore('.colection_search_head')
//           	}
//             var array = productSuggestions;
//             var check_exist = false;
//             $.each(array, function(key,value) {
//              var prodTitle = value.title;
//              var checkTitle = prodTitle.includes(q);
//              var check_handle = value.handle;
//            $('.predictive-search__list-item').each(function(){
//             var get_handle = $(this).find('h3.predictive-search__item-heading').attr('prodhandle');
//                if(get_handle == check_handle){
//                  check_exist = true;
//                }
//             });
//                 if(check_exist == false){
//                   $('.product-tag-search-heading').css('display','block');
//                   $('.predictive-search-product-tag').append(`
//                 <li id="predictive-search-option-1" class="predictive-search__list-item" role="option" aria-selected="false">
//                   <a href="${value.url}" class="predictive-search__item predictive-search__item--link link link--text" tabindex="-1"><div class="predictive-search__item-content predictive-search__item-content--centered"><h3 class="predictive-search__item-heading h5">${value.title}</h3></div>
//                   </a>
//                 </li>`)  
//                 }
//         });
//       }
//    });
// });
// });
// Predictive Search for Product Tag End (3)

// Predictive Search for Collection Metafieled Tag Start
// $('.search__input').on('keyup',function(e){
// setTimeout(()=>{
// var q = e.target.value;
// $(".collection_items").hide();
//   var count= 0
//   $(".collection_items").each(function(e){

//     var Each_handle=$.trim($(this).attr("data-metafields"));
//     var data_final = Each_handle.includes(q);
//     if(data_final){
//       $(this).show();
//     }
    
//   });
//   var path = window.location.pathname;
//    if(path != '/search') {
//        $(".collection_items:visible").each(function(){
//    count++;
//       if(count < 4){
//       $(this).show();
//       }else{
//          $(this).hide();
//       }
//   });
//    } 

//      var main_val =  $(".collection_items:visible").length;
//        if(main_val < 1){
//          $(".colection_search_head").hide();
//        }else{
//          $(".colection_search_head").show();
//        }
//   },1500);
//  });
// Predictive Search for Collection Metafieled Tag End


$(document).on('click','.collection-sidebar-menu-mobile',function(){
    $('.menu-drawer-container').addClass("menu-opening");
  setTimeout(function(){
    $('.menu-drawer-container').attr("open","open");
  },100);
$("li.megaMenuExist .megaMenu").slideDown();

})

// Showing Products on Click of Product Type in megamanu Ajax (Collection Page) Start



// Showing Products on Click of Product Type in megamanu Ajax (Collection Page) End

// Product Type, Trending , Categories Mobile Menu Accordion Start
if ($(window).width() < 990) {
$('.mMenuCollection .mMenu').addClass('active');
$('.mMenuCollection .mMenu').click(function(e){
   $(this).toggleClass('active');
   e.stopPropagation();
});

$('.mMenuCollection .mMenu').click(function(e){
   var checkClass = $(this).hasClass('active');
   if(checkClass == false) {
       $(this).find('.list-unstyled').slideUp(200);
   } else {
       $(this).find('.list-unstyled').slideDown(200);
   }
   e.stopPropagation();
});
  
$('.megaMenuExist_mobile .mMenuProdType').addClass('active');
$('.megaMenuExist_mobile .productTypeHeading').click(function(e){
   $('.megaMenuExist_mobile .mMenuProdType').toggleClass('active');
   e.stopPropagation();
});

$('.megaMenuExist_mobile .productTypeHeading').click(function(e){
  var checkCls = $('.megaMenuExist_mobile .mMenuProdType').hasClass('active');
   if(checkCls == false) {
       $(this).next().slideUp(200);
   } else {
       $(this).next().slideDown(200);
   }
   e.stopPropagation();
});
  
$('.mMenu .list-unstyled a').click(function(e){
    e.stopPropagation();
});
$('.typesBlock a').click(function(e){
    e.stopPropagation();
});
}
// Product Type, Trending , Categories Mobile Menu Accordion End

// Hide Recently Viewed Section when length is 0 Start



setTimeout(function(){
var check_length = $("div#recently_product_wrapp .recently-viewed .grid__item").length;
if(check_length < 5 ){
    $("div#recently_product_wrapp .slider-buttons").addClass('hide_buttons_custom');
}
},500);
// Hide Recently Viewed Section when length is 0 End

   $(document).on("click",".mMenuSection .typesBlock a",function(e) {
// if(window.location.href.indexOf("products") > -1)
//     {
//     }else{
//         e.preventDefault();
//     }
     
             e.stopPropagation();
        $(".mMenuSection .typesBlock a").removeClass('active');
        $(this).addClass('active');
     var get_type = $(this).attr("data-type");
       var get_anchor = $(this).attr('href');
                     
    });
     
$(".menu-drawer__menu .mMenuSection .typesBlock a").click(function(e){
  // if(window.location.href.indexOf("products") > -1)
  //   {
  //   }else{
  //       e.preventDefault();
  //   }
      
             e.stopPropagation();
        $(".mMenuSection .typesBlock a").removeClass('active');
        $(this).addClass('active');
       var get_anchor = $(this).attr('href');
               $.ajax({
            url: get_anchor,
            type: "GET",
            dataType: "html",
            success: function(data) {
              $('.mainColTemp').html($(data).find('.mainColTemp').html());
              //  $("span.closeMenu.small-hide").trigger('click');
            setTimeout(function(){
              $("body").removeClass('overflow-hidden');
           },500);
                $(".header__icon").trigger('click');
            },


          });             
    });
// if($(window).width() > 990 ){     
// $(document).click(function(e){

// // Check if click was triggered on or within #menu_content
// if( $(e.target).closest(".megaMenu").length == 0  && $(e.target).closest(".header__inline-menu").length == 0) {
// $(".closeMenu").trigger("click");
// }

// // Otherwise
// // trigger your click function
// });  
// }
// else{
//   $(document).click(function(e){

// if( $(e.target).closest("#menu-drawer").length == 0 && $(e.target).closest("#Details-menu-drawer-container") ) {
// $("#Details-menu-drawer-container").removeAttr("open");
// $("body").removeClass("overflow-hidden-tablet");  
// }

// });
// }

//
// setInterval(function() {
// $(".collection-sidebar-menu a").each(function(){
// var url = $(this).attr("href");

// $(".mMenuSection a[href='"+url+"']").html( $(this).find("p").html());    
    
// });
// }, 150);
//
// var homeurl = $(".col-hnhome-home-url").val();
// $(".mMenuSection a[href='"+homeurl+"']").addClass("list-menu__item--active");

var activeurl  = $(".typesBlock a.active").attr("href");
$(".header__inline-menu .typesBlock a[href='"+activeurl+"']").addClass("active");
$(".menu-drawer__inner-container a[href='"+activeurl+"']").addClass("active"); 


var acurl = $(".mMenuCollection a.list-menu__item--active").attr("href");


$(document).on("click","#Details-menu-drawer-container",function(){
$(".custom_main_menu").addClass("open");
$(".menu-drawer__submenu").show();
});



// var urls = $(".mMenuSection .typesBlock a.active").attr("href");
// if (typeof(urls) != "undefined")
// {
// var myArray = urls.split("?");
// $(".mMenuCollection a").each(function(){
//    var curl = $(this).attr("href")+"?"+myArray[1]; 
//     $(this).attr("href",curl);
// });
// }

if($(window).width() < 1000){ 
setTimeout(function(){
if ($("body").hasClass("temp-collection")) {
$('html, body').animate({
        scrollTop: $(".prodTypes a.active").offset().top-190
    }, 1000);
}
   
  },750);
}


$(document).on("click",".custom_main_menu .custom_main_menus a.list-menu__item--link",function(e) {
   if (window.location.href.indexOf("/pages") > -1 || window.location.href.indexOf("/products") > -1 || window.location.href.indexOf("/blogs") > -1) {
    
  }else{
 e.preventDefault();
   var main_url_data = $(this).attr("data-url");
    window.location.href = main_url_data;
   }
});
$(document).mouseup(function (e) { 
if ($(e.target).closest("li.megaMenuExist").length 
          === 0) { 
  $(".megaMenu").slideUp(); 
} 
}); 

// Manny 11-17-23 change to float category button and show after scroll depth

window.addEventListener('scroll', function() {
    var scrollPosition = window.scrollY || document.documentElement.scrollTop;
    var button = document.querySelector('.category_btn button.cstm_category_btn');

    if (scrollPosition > 175) { // The button will appear after 200px of scrolling
        button.style.visibility = 'visible';
    } else {
        button.style.visibility = 'hidden';
    }
});


// Manny 11-17-23 Change announcement bar to show promo code after klaviyo popup form submitted

const desktopFormId = 'S3X89Q';
const mobileFormId = 'VenEHk';

window.addEventListener('klaviyoForms', e => {
  if ([desktopFormId, mobileFormId].includes(e.detail.formId) && e.detail.type === 'submit') {
    localStorage.setItem('signedUp', 'true');
    updateAnnouncementBar();
  }
});

function updateAnnouncementBar() {
  if (localStorage.getItem('signedUp') === 'true') {
    var announcementBar = document.querySelector('#shopify-section-announcement-bar .announcement-bar__message');
    if (announcementBar) {
      announcementBar.innerHTML = '<span style="font-size:16px !important; color:#ffffff !important;">Use <span style="color:#e22120;">CANCELME10</span> for 10% off &bull; Free shipping $75+</span>';
    }
  }
}

function triggerForm() {
  if (localStorage.getItem('signedUp') !== 'true' && localStorage.getItem('popupShown') !== 'true') {
    window._klOnsite = window._klOnsite || [];
    const formId = $(window).width() < 750 ? mobileFormId : desktopFormId;
    window._klOnsite.openForm(formId);
    localStorage.setItem('popupShown', 'true'); // Set the flag indicating the popup has been shown
  }
}


document.querySelector('a[href="#klaviyo"]').addEventListener('click', function() {
  triggerForm();
});

// Setup delayed popup trigger
document.addEventListener('DOMContentLoaded', function() {
  if (localStorage.getItem('signedUp') !== 'true' && localStorage.getItem('popupShown') !== 'true') {
    setTimeout(triggerForm, 30000);
  }
});


window.addEventListener('load', updateAnnouncementBar);


